import React from 'react';
import Container from '../common/Container';
import Button from '../common/Button';

const HeroSection = () => (
  <section className="overflow-hidden bg-slate-950">
    <Container className="grid min-h-[460px] items-center gap-10 py-16 md:grid-cols-2 md:py-20">
      <div className="relative z-10 max-w-xl">
        <p className="mb-5 text-sm font-bold uppercase tracking-[0.22em] text-indigo-300">Thoughtfully selected</p>
        <h1 className="text-4xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl">Everyday pieces, elevated.</h1>
        <p className="mt-6 max-w-lg text-lg leading-8 text-slate-300">Discover reliable essentials and distinctive finds across fashion, jewellery, and technology.</p>
        <a href="#products"><Button title="Explore the collection" className="mt-8 bg-indigo-500 hover:bg-indigo-400" /></a>
      </div>
      <div className="relative hidden min-h-[320px] md:block">
        <div className="absolute inset-0 rounded-[2rem] border border-white/15 bg-gradient-to-br from-indigo-500 via-violet-500 to-fuchsia-500 opacity-90" />
        <div className="absolute inset-8 rounded-[1.5rem] border border-white/30 bg-slate-950/20 backdrop-blur-sm" />
        <p className="absolute bottom-12 left-12 text-5xl font-black tracking-tight text-white/95">SHOP<br />SMARTER.</p>
      </div>
    </Container>
  </section>
);

export default HeroSection;
